module.exports = __webpack_public_path__ + "media/images/icon-dot-gov-42b4ac468597239a3d96db04c363277e.svg";